import { Component } from '@angular/core';

@Component({
  selector: 'app-rulebook',
  standalone: false,
  templateUrl: './rulebook.html',
  styleUrl: './rulebook.css'
})
export class Rulebook {

  expandedSections: { [key: string]: boolean } = {};

  scrollTo(event: Event, sectionId: string): void {
    event.preventDefault();
    event.stopPropagation();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  toggleSection(section: string): void {
    this.expandedSections[section] = !this.expandedSections[section];
  }
}
